import { Component, Input } from '@angular/core';
import { FormGroup, UntypedFormControl } from '@angular/forms';
import { Lookup } from '@core/services/models/shared/lookup';
import { FieldComponentTypeEnum } from '@views/create/create-programme/constants';

@Component({
  selector: 'app-range-input',
  templateUrl: './range-input.component.html'
})
export class RangeInputComponent {
  @Input() manageForm: FormGroup;
  @Input() fromLabel: string;
  @Input() toLabel: string;

  @Input() fromFormControlName: string;
  @Input() toFormControlName: string;

  @Input() adjacentTextFrom: string;
  @Input() adjacentTextTo: string;

  @Input() lookupOptionFrom: Lookup<any>[] = [];
  @Input() lookupOptionTo: Lookup<any>[] = [];

  @Input() fieldComponentType: string;
  @Input() label: string;
  @Input() validationProperty: string;
  @Input() step: string = '0.1';
  @Input() attributeId = 'default';
  @Input() showHelpText: boolean = false;
  @Input() isEditMode: boolean = true;
  @Input() isViewMode: boolean = false;
  @Input() isDraftVersion: boolean = false;
  @Input() isApprovingDraft: boolean = false;

  get isFormTouched(): boolean | undefined {
    return this.manageForm.get(this.fromFormControlName)?.dirty || this.manageForm.get(this.toFormControlName)?.dirty;
  }

  public readonly FieldComponentTypeEnum = FieldComponentTypeEnum;

  creditRangeError: boolean;

  get controlFrom(): UntypedFormControl {
    return this.manageForm?.get(this.fromFormControlName) as UntypedFormControl;
  }

  get controlTo(): UntypedFormControl {
    return this.manageForm?.get(this.toFormControlName) as UntypedFormControl;
  }

  get controlFromErrorMessageText(): string {
    return this.manageForm?.errors?.[this.validationProperty]?.fromValidationMessage;
  }

  get controlToErrorMessageText(): string {
    return this.manageForm?.errors?.[this.validationProperty]?.toValidationMessage;
  }

  shouldShowHelpTextForFromControl(): boolean {
    if (
      !this.showHelpText ||
      !this.isEditMode ||
      !this.isDraftVersion ||
      this.isApprovingDraft ||
      (this.controlFrom?.value != null && this.controlFrom?.value !== '') ||
      this.controlFrom?.disabled
    ) {
      return false;
    }

    const fromControl = this.manageForm?.get(this.fromFormControlName);
    if (!fromControl) {
      return false;
    }

    const hasWarning = (fromControl as any)?.warnings?.['requiredToApprove'] != null;
    const hasRequiredError = fromControl?.errors?.['required'] != null && (fromControl?.touched || fromControl?.dirty);
    const isShowingValidation = fromControl?.invalid && (fromControl?.touched || fromControl?.dirty);
    const hasErrorMessage = this.controlFromErrorMessageText && this.controlFromErrorMessageText > '';
    const isTouchedOrShowingValidation = this.isFormTouched || isShowingValidation;

    return (
      !hasWarning && !hasRequiredError && !isShowingValidation && !(hasErrorMessage && isTouchedOrShowingValidation)
    );
  }

  shouldShowHelpTextForToControl(): boolean {
    if (
      !this.showHelpText ||
      !this.isEditMode ||
      !this.isDraftVersion ||
      this.isApprovingDraft ||
      (this.controlTo?.value != null && this.controlTo?.value !== '') ||
      this.controlTo?.disabled
    ) {
      return false;
    }

    const toControl = this.manageForm?.get(this.toFormControlName);
    if (!toControl) {
      return false;
    }

    const hasWarning = (toControl as any)?.warnings?.['requiredToApprove'] != null;
    const hasRequiredError = toControl?.errors?.['required'] != null && (toControl?.touched || toControl?.dirty);
    const isShowingValidation = toControl?.invalid && (toControl?.touched || toControl?.dirty);
    const hasErrorMessage = this.controlToErrorMessageText && this.controlToErrorMessageText > '';
    const isTouchedOrShowingValidation = this.isFormTouched || isShowingValidation;

    return (
      !hasWarning && !hasRequiredError && !isShowingValidation && !(hasErrorMessage && isTouchedOrShowingValidation)
    );
  }
}
